import React, { useState, useRef } from 'react';
import InfoTracking from '@app/components/common/InfoTracking';
import { Button, Col, Switch, DatePicker, Drawer, Form, Input, Row, Select, InputNumber, Space, message, Tooltip } from 'antd';
import { CloseOutlined, CheckOutlined, InfoCircleOutlined } from '@ant-design/icons';
import {insertDetail, getDetail, updateDetail} from '../../../../../apis/CalculosApi';
import moment from 'moment';
import './styles.scss';
const { Option } = Select;

const formItemLayout = {
    labelCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 4,
      },
    },
    wrapperCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 20,
      },
    },
  };
const formItemLayoutWithOutLabel = {
    wrapperCol: {
        xs: {
        span: 24,
        offset: 0,
        },
        sm: {
        span: 20,
        offset: 4,
        },
    },
};

const App = ({title, definicionId, definicion, id, open, finish}) => {
    const [ form ] = Form.useForm()
    const [ID, setID] = useState(id);
    const [showModal, setShowModal] = useState(false);
    const [initialValues, setInitialValues] = useState(null);
    const [etiquetas, setEtiquetas] = useState([]);
    const [initValuesTags, setInitValuesTags] = useState([]);

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            if(!values) return;
        } catch (errorInfo) {
            console.log('Failed:', errorInfo);
            return;
        }

        const fields = form.getFieldsValue()
        var defaultValue = {}
        var values = [];
        var i = 0;
        Object.keys(fields).forEach(function(key, index, v) {
            if(key.includes("value_")){
                var tag = etiquetas[i];
                let value = fields[key];
                if(value == undefined){
                    value = initValuesTags[i].value;
                }
                values.push({index: i, tag: tag.title, name: tag.name, value: value});
                i++;
            }
        });
        let success = false;
        if(ID > 0){
            const payload = {
                id: ID,
                ...defaultValue,
                ...fields,
                calculo_definicion_id: definicionId,
                valores: JSON.stringify(values)
            }
            const response = await updateDetail(payload);
            success = response.ok;
            if(response.ok){
                message.success('Se guardo correctamente la linea!');
            }
        }else{
            const payload = {
                ...fields,
                calculo_definicion_id: definicionId,
                valores: JSON.stringify(values)
            }
            const response = await insertDetail(payload);
            success = response.ok;
            if(response.ok){
                message.success('Se guardo correctamente la linea!');
            }
        }
        
        if(success){
            setShowModal(false);
            finish(true);
        }
    }

    const onClose = ()=>{
        setShowModal(false);
        finish(false);
    }

    React.useEffect(() => {
        setShowModal(open);
    }, [open]);

    React.useEffect(() => {
        setID(id);
    }, [id]);


    const effectRan = useRef(false);
    React.useEffect(() => {

      if (!effectRan.current) {
        (async ()=>{
            if(ID > 0){
                await refreshData();
            }else{
                let tags = [];
                let etiquetas = []
                if(typeof definicion?.etiquetas === 'string'){
                    etiquetas = JSON.parse(definicion?.etiquetas) || [];
                }else{
                    etiquetas = definicion?.etiquetas;
                }
                for (let index = 0; index < etiquetas.length; index++) {
                    const item = etiquetas[index];
                    tags.push({index: item.index, title: item.tag, name: item.name, value: ''});
                }
                setEtiquetas(tags);
                setInitialValues({
                    cuenta: '',
                    activo: true,
                });
            }
        })()
      }
    
      return () => effectRan.current = true;
    }, [ID]);

    const refreshData = async ()=> {
        if(ID > 0){
            const response = await getDetail(ID);
            if(response.ok){
                let detail = response.payload;
                let values = [];
                var valores = JSON.parse(detail?.valores) || [];
                for (let index = 0; index < valores.length; index++) {
                    const item = valores[index];
                    values.push({index: item.index, title: item.tag, name: item.name, value: item.value});
                }
                setInitValuesTags(valores);
                setEtiquetas(values);
                if(detail.fecha_inicial){
                    detail.fecha_inicial = moment(detail.fecha_inicial, 'YYYY-MM-DD');
                }

                setInitialValues(detail);
            }
            }else{
                setInitialValues({
                    activo: true
                });
            }
    }

  return (
    <>
      <Drawer
        title={title}
        width={720}
        placement={"right"}
        onClose={onClose}
        open={open}
        closable={true}
        height={'80%'}
        onFinish={handleOk}
        styles={{
          body: {
            paddingBottom: 80,
          },
        }}
        extra={[
            <Space>
                {ID && <InfoTracking entity={'ConfiguracionPeriodoDetalle'} entityId={ID}/>}
                <Button onClick={onClose}>Cancelar</Button>
                <Button onClick={handleOk} type="primary">
                Guardar
                </Button>
            </Space>
        ]}
      >
        {
            initialValues && 
            <Form layout="vertical" form={form} hideRequiredMark onFinish={handleOk} initialValues={initialValues}>
                <Row gutter={16}>
                    <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                        <Form.Item
                            name="fecha_inicial"
                            label="Fecha Inicial"
                        >
                            <DatePicker placeholder="DD/MM/YYYY"  style={{width: '100%',}} format={'DD/MM/YYYY'}/>
                        </Form.Item>
                    </Col>
                    <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                        <Form.Item
                            name="activo"
                            label="Activo"
                            >
                            <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />}/>
                        </Form.Item>
                    </Col>
                    {etiquetas.map((field, index) => (
                    <Col md={{span: 20}} sm={{span: 20}} xs={{span: 20}}>
                        <Form.Item
                            name={"value_" + field.index}
                            label={
                                <div>
                                    {field.title} {" "}
                                    <Tooltip title={field.name}>
                                        <InfoCircleOutlined />
                                    </Tooltip>
                                </div>
                            }
                            style={{
                                width: '60%',
                            }}
                            >
                            <InputNumber
                                style={{
                                    width: '60%',
                                }}
                                placeholder={'Valor'}
                                defaultValue={field.value}
                            />
                        </Form.Item>
                    </Col>))}
                </Row>
            </Form>
        }
      </Drawer>
    </>
  );
};
export default App;